module.exports = __webpack_public_path__ + "img/OpenBG.b6ab5e32.png";